module.exports = __webpack_public_path__ + "static/sc21-ec3f53365aba666faf5e5a1b71c01e27.png";